import { Text } from '@mxenabled/mxui'

interface TabTitleProps {
  title: string
}

export const TabTitle = ({ title }: TabTitleProps) => (
  <Text bold={true} variant="body1">
    {title}
  </Text>
)
